// City suggestions already used elsewhere in the back office. "Other city"
// keeps the notification form usable until a complete location API is available.
export const notificationProvinceOptions = [
  { value: "AB", label: "Alberta" },
  { value: "BC", label: "British Columbia" },
  { value: "MB", label: "Manitoba" },
  { value: "NB", label: "New Brunswick" },
  { value: "NL", label: "Newfoundland and Labrador" },
  { value: "NS", label: "Nova Scotia" },
  { value: "NT", label: "Northwest Territories" },
  { value: "NU", label: "Nunavut" },
  { value: "ON", label: "Ontario" },
  { value: "PE", label: "Prince Edward Island" },
  { value: "QC", label: "Quebec" },
  { value: "SK", label: "Saskatchewan" },
  { value: "YT", label: "Yukon" },
];

export const notificationCitiesByProvince: Record<string, string[]> = {
  AB: ["Calgary"],
  BC: ["Vancouver"],
  MB: ["Winnipeg"],
  ON: ["Ottawa", "Toronto"],
  QC: ["Montreal"],
};

export const OTHER_CITY = "__other__";
